<div class="form-container">
    <h2>Edit Energy Option</h2>

    <form [formGroup]="energyOptionForm" (ngSubmit)="updateEnergyOption()">
        <div class="form-group">
                    <div class="form-group">
            <label for="scenarioCategoryId">Scenario Category:</label>
            <select class="form-control" formControlName="scenarioCategoryId" id="scenarioCategoryId">
                <option *ngFor="let category of categories" [value]="category.id">{{ category.title }}</option>
            </select>
            <div *ngIf="errors.scenarioCategoryId" class="text-danger">
                <ul>
                    <li *ngFor="let error of errors.scenarioCategoryId">{{ error }}</li>
                </ul>
            </div>
        </div>
            <label>Title:</label>
            <input type="text" class="form-control" formControlName="title" placeholder="Energy Option Title">
            <div *ngIf="errors.title" class="text-danger">
                <ul>
                    <li *ngFor="let error of errors.title">{{ error }}</li>
                </ul>
            </div>
        </div>

        <div class="form-group">
            <label>Coefficient:</label>
            <input type="number" class="form-control" formControlName="coefficient" placeholder="Coefficient">
            <div *ngIf="errors.coefficient" class="text-danger">
                <ul>
                    <li *ngFor="let error of errors.coefficient">{{ error }}</li>
                </ul>
            </div>
        </div>

        <div class="form-group">
            <label>Description:</label>
            <textarea class="form-control" formControlName="description"
                [attr.placeholder]="energyOptionForm.get('description')?.value ? null : 'Enter description here...'" rows="3">
                    </textarea>
                    
        
            <div *ngIf="errors.description" class="text-danger">
                <ul>
                    <li *ngFor="let error of errors.description">{{ error }}</li>
                </ul>
            </div>
        </div>



        <div *ngIf="errors.general" class="text-danger">
            <ul>
                <li *ngFor="let error of errors.general">{{ error }}</li>
            </ul>
        </div>

        <button type="submit" class="btn btn-primary">
            {{ isSubmitting ? 'Updating...' : 'Update Energy Option' }}
        </button>
    </form>
</div>